import React from 'react';
import { Link } from 'react-router';
import {
  JOIN_COMMISSIONER_SECONDARY_NOTE,
  type JoinInviteRecovery,
} from '../joinInviteErrors';
import { JOIN_BAD_INVITE_ASK_COMMISSIONER } from '../joinMemberCopy';
import { lscPath } from '../routing';

const RECOVERY_COMMISSIONER = {
  code: 'commissioner',
  label: 'Start a league as commissioner',
  href: '/pricing',
} as const;

interface JoinInviteRecoveryPanelProps {
  recovery: JoinInviteRecovery;
  testId?: string;
}

const JoinInviteRecoveryPanel: React.FC<JoinInviteRecoveryPanelProps> = ({
  recovery,
  testId = 'join-invite-recovery-panel',
}) => {
  const secondaryWithoutPrimary = recovery.secondaryCtas.filter(
    (cta) => cta.code !== recovery.primaryCta?.code
  );

  return (
    <div className="card space-y-4" data-testid={testId} data-recovery-code={recovery.code}>
      <div className="space-y-2">
        <h2 className="text-lg font-semibold text-white">{recovery.headline}</h2>
        <p className="text-sm text-secondary-300">{recovery.message}</p>
        {recovery.message.indexOf(JOIN_BAD_INVITE_ASK_COMMISSIONER) === -1 ? (
          <p className="text-sm text-secondary-400">{JOIN_BAD_INVITE_ASK_COMMISSIONER}</p>
        ) : null}
      </div>

      <div className="flex flex-wrap gap-2" data-testid={`${testId}-actions`}>
        {recovery.primaryCta ? (
          recovery.primaryCta.href ? (
            <Link
              to={lscPath(recovery.primaryCta.href)}
              className="btn-primary text-sm"
              data-testid={`${testId}-primary-${recovery.primaryCta.code}`}
            >
              {recovery.primaryCta.label}
            </Link>
          ) : (
            <span className="text-sm text-secondary-400">{recovery.primaryCta.label}</span>
          )
        ) : null}
        {secondaryWithoutPrimary.map((cta) =>
          cta.href ? (
            <Link
              key={cta.code}
              to={lscPath(cta.href)}
              className="btn-secondary text-sm"
              data-testid={`${testId}-secondary-${cta.code}`}
            >
              {cta.label}
            </Link>
          ) : null
        )}
      </div>

      {recovery.showCommissionerSecondary ? (
        <div
          className="rounded-lg border border-secondary-700 bg-secondary-900/40 px-3 py-3 space-y-2"
          data-testid={`${testId}-commissioner-secondary`}
        >
          <p className="text-xs text-secondary-400">{JOIN_COMMISSIONER_SECONDARY_NOTE}</p>
          <Link
            to={lscPath('/pricing')}
            className="text-sm text-primary-300 hover:text-primary-200"
            data-testid={`${testId}-commissioner-pricing`}
          >
            {RECOVERY_COMMISSIONER.label}
          </Link>
        </div>
      ) : null}
    </div>
  );
};

export default JoinInviteRecoveryPanel;
